export var VerdantColorSchemes;
(function (VerdantColorSchemes) {
    VerdantColorSchemes["base"] = "base";
    VerdantColorSchemes["positive"] = "positive";
    VerdantColorSchemes["negative"] = "negative";
    VerdantColorSchemes["warning"] = "warning";
    VerdantColorSchemes["info"] = "info";
    VerdantColorSchemes["neutral"] = "neutral";
})(VerdantColorSchemes || (VerdantColorSchemes = {}));
export var VerdantVariants;
(function (VerdantVariants) {
    VerdantVariants["highEmphasis"] = "high-emphasis";
    VerdantVariants["mediumEmphasis"] = "medium-emphasis";
    VerdantVariants["lowEmphasis"] = "low-emphasis";
    VerdantVariants["noEmphasis"] = "no-emphasis";
})(VerdantVariants || (VerdantVariants = {}));
export var VerdantIconSizes;
(function (VerdantIconSizes) {
    VerdantIconSizes["sm"] = "14px";
    VerdantIconSizes["md"] = "18px";
    VerdantIconSizes["lg"] = "24px";
})(VerdantIconSizes || (VerdantIconSizes = {}));
export var VButtonSizes;
(function (VButtonSizes) {
    VButtonSizes["lg"] = "lg";
    VButtonSizes["md"] = "md";
    VButtonSizes["sm"] = "sm";
})(VButtonSizes || (VButtonSizes = {}));
export var VLinkSizes;
(function (VLinkSizes) {
    VLinkSizes["sm"] = "sm";
    VLinkSizes["md"] = "md";
})(VLinkSizes || (VLinkSizes = {}));
export var VIconButtonSizes;
(function (VIconButtonSizes) {
    VIconButtonSizes["lg"] = "lg";
    VIconButtonSizes["md"] = "md";
    VIconButtonSizes["sm"] = "sm";
    VIconButtonSizes["xs"] = "xs";
    VIconButtonSizes["2xs"] = "2xs";
    VIconButtonSizes["3xs"] = "3xs";
})(VIconButtonSizes || (VIconButtonSizes = {}));
